import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { useTranslation } from "react-i18next";
import { ModelFamilyFormFields } from "../_components/model-family-form-fields";

export function ModelFamilyCreateView() {
  const { t } = useTranslation(["masterdata", "common"]);
  const pageTitle = t("masterdata:CreateModelFamily");
  const pageSubtitle = t("common:CompleteRequiredInformationDescription");

  return (
    <CenteredLayout variant={CenteredLayoutVariant.Form} title={pageTitle} subTitle={pageSubtitle}>
      <ModelFamilyFormFields />
    </CenteredLayout>
  );
}
